import React, { useEffect, useState } from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useSubmit from 'hooks/useSubmit';
import InvestmentAccount from 'services/api/InvestmentAccount';
import SuccessMessage from '../SuccessMessage';
import {
  MODAL_ACTIVE_ACCOUNT,
  MODAL_DISABLED_ACCOUNT,
} from '../../../constants/utils';

type ActiveAccountModalProps = {
  show: boolean,
  account: { id:number;
    fullName:string;
    action: typeof MODAL_DISABLED_ACCOUNT | typeof MODAL_ACTIVE_ACCOUNT },
  onClose: () => void,
  reloadData: () => void,
};

function ActiveAccountModal( {
  show, onClose, account, reloadData,
}: ActiveAccountModalProps ) {
  const { t } = useTranslation();
  // const [discardedAccount, setDiscardedAccount] = useState( false );
  const [formSubmitted, setFormSubmitted] = useState( false );
  const [formSubmittedError, setFormSubmittedError] = useState( '' );

  const submitForm = useSubmit( {
    promise: ( ) => {
      if ( account.action === MODAL_ACTIVE_ACCOUNT ) {
        return InvestmentAccount.getActiveInvestmentAccounts( account.id );
      }
      return InvestmentAccount.getDisableInvestmentAccounts( account.id );
    },
    callbackError: ( errors ) => {
      setFormSubmitted( true );
      setFormSubmittedError( errors );
    },
    callback: ( ) => {
      setFormSubmitted( true );
      setFormSubmittedError( '' );
      reloadData();
    },
    showAlert: false,
    deps: [account],
  } );

  useEffect( () => {
    if ( !show ) setFormSubmitted( false );
  }, [show] );

  let description = '¿Desea bloquear la cuenta ';
  let title = t( 'admin.common.activeAccount' );
  let formSubmittedDescripcion = t( 'admin.common.changeAccountStatusSuccess' );
  if ( account.action === MODAL_ACTIVE_ACCOUNT ) {
    title = t( 'admin.common.disabledAccount' );
    description = '¿Desea desbloquear la cuenta ';
    formSubmittedDescripcion = t( 'admin.common.changeAccountStatusSuccess' );
  }

  return (
    <Modal
      show={show}
      className="modal-carousel"
      centered
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">{title}</h3>
            {formSubmitted
              ? (
                <SuccessMessage
                  description={!formSubmittedError ? formSubmittedDescripcion : formSubmittedError}
                  onClose={onClose}
                  success={!formSubmittedError}
                />
              )
              : (
                <div className="text-center">
                  <p className="text--sm">
                    {description}
                    <span className="text--bold">
                      {' '}
                      {account.fullName}
                      {' '}
                    </span>
                    ?
                  </p>
                  <Row>
                    <Col className="m-auto mt-3">
                      <Button variant="outline-primary" className="btn--full-width" onClick={onClose}>
                        {t( 'cancel' )}
                      </Button>
                    </Col>
                    {account.action === MODAL_DISABLED_ACCOUNT && (
                    <Col className="m-auto mt-3">
                      <Button variant="danger" className="btn--full-width" onClick={() => submitForm( { id: account.id } )}>
                        {t( 'block' )}
                      </Button>
                    </Col>
                    )}
                    {account.action === MODAL_ACTIVE_ACCOUNT && (
                    <Col className="m-auto mt-3">
                      <Button className="btn--full-width" onClick={() => submitForm( { id: account.id } )}>
                        {t( 'unblock' )}
                      </Button>
                    </Col>
                    )}
                  </Row>

                </div>
              )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default ActiveAccountModal;
